import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  margin-bottom: 1rem;
  border-radius: 50rem;
  border: 0.5rem solid var(--primary-50);
  background-color: var(--primary-100);
  width: 3rem;
  height: 3rem;
  stroke: var(--primary-600);

  svg {
    position: absolute;
    width: 1.25rem;
    height: 1.25rem;
    top: 0.375rem;
    left: 0.375rem;
  }
`;

type Props = {
  icon: JSX.Element;
};
const FeaturedIcon: FC<Props> = ({ icon }) => {
  return <Container>{icon}</Container>;
};

export default FeaturedIcon;
